/**
 * Client-side checks for PRINTEMPSROBOUP campaign UI.
 * Server enforces eligibility; keep rules aligned with server/api-util/promoPrintempsRoboup.js.
 */

const PARIS_TZ = 'Europe/Paris';

const calendarYearMonthInTimeZone = (date, timeZone) => {
  if (typeof Intl === 'undefined') return null;
  try {
    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone,
      year: 'numeric',
      month: 'numeric',
    });
    const parts = formatter.formatToParts(date);
    const year = Number(parts.find(p => p.type === 'year')?.value);
    const month = Number(parts.find(p => p.type === 'month')?.value);
    if (!Number.isFinite(year) || !Number.isFinite(month)) return null;
    return { year, month };
  } catch {
    return null;
  }
};

/**
 * Weekend extension: 2026-04-10 00:00 – 2026-04-12 23:59:59.999 Europe/Paris (CEST +02).
 */
export const getCampaignStartDate = () => new Date('2026-04-10T00:00:00+02:00');

/**
 * Returns a Date object for the campaign deadline: 2026-04-12 23:59:59.999 Europe/Paris.
 */
export const getCampaignEndDate = () => new Date('2026-04-12T23:59:59.999+02:00');

/** Campaign active during the extended weekend window (Paris). */
export const isApril2026CampaignActive = () => {
  if (typeof Date === 'undefined') return false;
  const now = new Date();
  return now >= getCampaignStartDate() && now <= getCampaignEndDate();
};

export const isUserSignupApril2026 = createdAt => {
  if (!createdAt) return false;
  const d = createdAt instanceof Date ? createdAt : new Date(createdAt);
  if (Number.isNaN(d.getTime())) return false;
  const ym = calendarYearMonthInTimeZone(d, PARIS_TZ);
  return ym?.year === 2026 && ym?.month === 4;
};

/** Align with server: `roboup` and common `iroboup` slug variant. */
export const normalizeRoboupBrandForPromo = raw => {
  const b = Array.isArray(raw) ? raw[0] : raw;
  if (typeof b !== 'string') return null;
  const normalized = b.trim().toLowerCase().replace(/^i(?=roboup$)/, '');
  return normalized === 'roboup' ? 'roboup' : null;
};

export const isRoboupLawnMowerListing = publicData => {
  if (!publicData || typeof publicData !== 'object') return false;
  if (publicData.categoryLevel1 !== 'lawn-mowers') return false;
  return normalizeRoboupBrandForPromo(publicData.brand) === 'roboup';
};
